import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Main.scss";
import { HOST, IMG_URL } from "../constants";
import { fetchWithTimeout } from "../helper";

const Movie = (props) => {
  const { poster_path, title, vote_average, overview } = props;
  const [overviewElement, setOverviewElement] = useState(null);
  const navigate = useNavigate();

  const getColor = (vote) => {
    if (vote >= 8) {
      return "green";
    } else if (vote >= 5) {
      return "orange";
    } else {
      return "red";
    }
  };

  const NavigateToSimilar = (e) => {
    // setRenderedMovieState("Similar");
    // debugger;
    // console.log("Movie props: ", props);
    console.log(e.target.className);
    if (e.target.className === "overview") {
      e.target.classList.add("clicked");
      setOverviewElement(e.target);
      return;
    }
    navigate(`/Similar/${encodeURI(title)}`, {
      state: props,
    });
  };

  const resetOverViewState = () => {
    if (overviewElement) {
      overviewElement.classList.remove("clicked");
    }
  };

  return (
    <div
      className="movie"
      onClick={NavigateToSimilar}
      onMouseLeave={resetOverViewState}
    >
      <div class="movie_img">
        <img
          src={`${
            poster_path
              ? IMG_URL + poster_path
              : "http://via.placeholder.com/1080x1580"
          }`}
          alt={title}
        />
        <div className="overview">
          <h3>Overview</h3>
          {overview}
        </div>
      </div>

      <div className="movie-info">
        <h3 class="pointTitle">{title}</h3>
        <span className={getColor(vote_average)}>{vote_average}</span>
      </div>
    </div>
  );
};

function Main(props) {
  const [movieDataArray, setMovieDataArray] = useState([]);
  const [isHidden, setIsHidden] = useState(true);
  const [isHiddenNetworkError, setIsHiddenNetworkError] = useState(true);

  // possible rendered states: initial, discovered, searched,similar
  const [renderedMoviesState, setRenderedMovieState] = useState("initial");
  const {
    selectedGenre,
    searchTerm,
    page,
    setPageNumber,
    setIsHiddenNavigationPage,
    searchCount,
    isSimilar,
    selectedMovieID,
    selectedMovieIDTitle,
    isMainHidden,
    setIsMainHidden,
  } = props;

  const initialrenderSelectedGenre = useRef(true);
  const initialrenderSearchTerm = useRef(true);

  useEffect(() => {
    if (initialrenderSelectedGenre.current) {
      initialrenderSelectedGenre.current = false;
      return;
    }

    getMovies(selectedGenre, "discover");
    setPageNumber(1);

    console.log("getMovies selectedGenre");
  }, [selectedGenre]);

  useEffect(() => {
    console.log("searchTerm change");
    if (initialrenderSearchTerm.current) {
      initialrenderSearchTerm.current = false;
      return;
    }

    console.log("getMovies searchterm");
    if (searchTerm.length === 0) {
      getMovies(null, null, false);
    } else {
      getMovies(searchTerm, "search");
    }
    setPageNumber(1);
  }, [searchTerm, searchCount]);

  const getMovies = (data, type, incKey = true, pageN = "1") => {
    console.log("getmovies: ", data);
    if (incKey === false) {
      setRenderedMovieState("initial");
    } else if (type === "discover") {
      setRenderedMovieState("discovered");
    } else if (type === "search") {
      setRenderedMovieState("searched");
    }

    setIsMainHidden(true);
    fetchWithTimeout(`${HOST}/movieData`, {
      method: "POST",
      timeout: 6000,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data,
        includeKey: incKey,
        type,
        page: pageN,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setIsMainHidden(false);
        console.log(data.results);
        setIsHiddenNetworkError(true);
        data.results = data.results.filter((res) => res !== null);
        if (data.results && data.results.length > 0) {
          setIsHidden(true);
          setIsHiddenNavigationPage(false);
          setMovieDataArray(data.results);
        } else {
          setIsHidden(false);
          setIsHiddenNavigationPage(true);
          setMovieDataArray(data.results);
        }
      })
      .catch((err) => {
        setIsMainHidden(false);
        console.log("err: ", err);
        setMovieDataArray([]);
        setIsHiddenNavigationPage(true);
        setIsHiddenNetworkError(false);
      });
  };

  useEffect(() => {
    console.log("page changed");
    if (renderedMoviesState === "initial") {
      getMovies(null, null, false, page);
    } else if (renderedMoviesState === "discovered") {
      getMovies(selectedGenre, "discover", true, page);
    } else if (renderedMoviesState === "searched") {
      getMovies(searchTerm, "search", true, page);
    }
  }, [page]);

  useEffect(() => {
    console.log(isSimilar);
    console.log("getmovies initial");
    if (isSimilar === false) {
      getMovies(null, null, false);
    } else {
      console.log("similar");
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      getMovies({ selectedMovieID, selectedMovieIDTitle }, "similar");
    }
  }, []);

  useEffect(() => {
    if (isSimilar !== false) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      getMovies({ selectedMovieID, selectedMovieIDTitle }, "similar");
    }
  }, [selectedMovieID]);

  const movies = movieDataArray.map((movieData) => {
    return (
      <Movie
        title={movieData.title}
        poster_path={movieData.poster_path}
        vote_average={movieData.vote_average}
        overview={movieData.overview}
        id={movieData.id}
      ></Movie>
    );
  });

  return (
    <main className={`${isMainHidden ? "none" : ""}`} id="main">
      {movies}
      <h1 className={`no-results ${isHidden ? "none" : ""}`}>
        No Results Found
      </h1>
      <h2 className={`no-results ${isHiddenNetworkError ? "none" : ""}`}>
        <span className="red large">OOPS!</span>
        <br />
        Something is Wrong
      </h2>
    </main>
  );
}

export default Main;
